import type { ReactNode } from 'react';

// Standard white section card. Matches the Connected Tenants cards — white
// surface, zinc-200 hairline border, 8px radius, 20px padding — so a section's
// content sits on a raised card instead of floating on the page background.
// The SectionLabel stays ABOVE the card (same pattern as Connected Tenants).
export default function SectionCard({
  children,
  className = '',
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={`rounded-lg border border-zinc-200 bg-white p-5 ${className}`}>{children}</div>
  );
}
